



















































































import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import MapMarker from '@/app/components/Field/Map/MapMarker.vue'
import SoilClass from '@/app/module/soil'

@Component({
  components: {
    MapMarker
  }
})
export default class Map extends Vue {
  private basicData: {[key:string]: string|any} = this.$store.state.mapState.basicData
  private selectedLayer: string = '0'
  private soilScale20: string[] = ['fukuoka_20', 'fukuoka_20-1', 'fukuoka_20-2', 'kagoshima_20', 'kagoshima_20-1', 'kumamoto_20', 'kumamoto_20-1', 'miyazaki_20', 'miyazaki_20-1', 'nagasaki_20', 'oita_20', 'oita_20-1', 'saga_20', 'saga_20-1']
  private soilScale5: string[] = ['fukuoka_5', 'fukuoka_5-1', 'fukuoka_5-2', 'fukuoka_5-3', 'kagoshima_5', 'kagoshima_5-1', 'kagoshima_5-2', 'kagoshima_5-3', 'kagoshima_5-4', 'kumamoto_5', 'kumamoto_5-1', 'kumamoto_5-2', 'kumamoto_5-3', 'kumamoto_5-4_kumamoto_5-5', 'miyazaki_5', 'miyazaki_5-1', 'miyazaki_5-2', 'miyazaki_5-3_saga_5-2', 'nagasaki_5', 'nagasaki_5-1', 'oita_5', 'oita_5-1', 'oita_5-2', 'saga_5', 'saga_5-1']
  private soilScales: string[] = []
  private soilScaleUrls: string[] = []
  private soilScale20Url: string[] = []
  private soilScale5Url: string[] = []
  private mapLayers: any = []
  private infoWindow: any = null
  private zoom: number = this.basicData.zoom
  private showLayerCredit: boolean = false

  created () {
    // kmlのURLを作成（googleのcash対策でパラメータにバージョンを追加）
    for (let i in this.soilScale20) {
      let url = process.env.VUE_APP_URL + '/kml/soil20/' + this.soilScale20[i] + '.kmz?' + process.env.VUE_APP_VERSION
      this.soilScale20Url.push(url)
    }
    for (let j in this.soilScale5) {
      let url = process.env.VUE_APP_URL + '/kml/soil5/' + this.soilScale5[j] + '.kmz?' + process.env.VUE_APP_VERSION
      this.soilScale5Url.push(url)
    }
  }

  @Prop() private mapData!: Array<{[key:string]: string|number|any}>

  /* computed */
  private get fieldChoiceState (): string {
    return this.$store.state.fieldChoiceState.id
  }

  @Watch('fieldChoiceState')
  onIdChange (newValue: string) : void {
    let id = parseInt(newValue)

    for (var i in this.mapData) {
      if (this.mapData[i].path.length !== 0) {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].path[0]
        }
      } else {
        if (this.mapData[i].id === id) {
          this.basicData.position = this.mapData[i].fieldPosition
        }
      }
    }
  }

  /* 同じ圃場を二回選択したときも強制的に中央にする */
  private get clickFlag (): boolean {
    return this.$store.state.fieldChoiceState.clickFlag
  }
  @Watch('clickFlag')
  getClickFlag (flag: boolean) : void {
    if (flag) {
      let id = this.$store.state.fieldChoiceState.id
      for (var i in this.mapData) {
        if (this.mapData[i].path.length !== 0) {
          if (this.mapData[i].id === id) {
            if (this.basicData.position === this.mapData[i].path[1]) {
              this.basicData.position = this.mapData[i].path[0]
            } else {
              this.basicData.position = this.mapData[i].path[1]
            }
          }
        } else {
          if (this.mapData[i].id === id) {
            this.basicData.position = this.mapData[i].fieldPosition
          }
        }
      }

      /* フラグリセット */
      this.$store.commit('fieldChoiceState/setClickFlag', false)
    }
  }

  private get getListLeadPosition (): any {
    return this.$store.state.mapState.basicData.position
  }
  @Watch('getListLeadPosition')
  getPosition (val: any) : void {
    this.basicData.position = val
  }

  private get changeLayer (): string {
    return this.selectedLayer
  }
  @Watch('changeLayer')
  changeMap (val: string) {
    if (val === '0') {
      this.showLayerCredit = false
      this.removeKml()
    } else {
      this.showLayerCredit = true
      if (this.zoom <= 12) {
        this.initMap('kml20')
      } else if (this.zoom > 12) {
        this.initMap('kml5')
      }
    }
  }

  // レイヤー表示切替
  private initMap (type: string) {
    let map: any = this.$refs.map
    // 空だった場合のみ
    if (this.infoWindow === null) {
      this.infoWindow = new google.maps.InfoWindow()
    }
    this.removeKml()
    this.mapLayers = []

    if (type === 'kml20') {
      this.soilScales = this.soilScale20
      this.soilScaleUrls = this.soilScale20Url
    } else {
      this.soilScales = this.soilScale5
      this.soilScaleUrls = this.soilScale5Url
    }

    for (let i in this.soilScales) {
      this.mapLayers[i] = new google.maps.KmlLayer({
        url: this.soilScaleUrls[i],
        suppressInfoWindows: true,
        preserveViewport: true
      })
      // レイヤーclick時
      this.mapLayers[i].addListener('click', (kmlEvent: any) => {
        this.infoWindow.setPosition(kmlEvent.latLng)
        this.infoWindow.setContent(this.showData(kmlEvent))
        this.infoWindow.open(map.$mapObject)
      })
    }
    this.addKml()
  }

  private addKml () {
    let map: any = this.$refs.map
    // KMLを描画
    for (let i in this.soilScales) {
      this.mapLayers[i].setMap(map.$mapObject)
    }
  }

  private removeKml () {
    // ポップアップを閉じる
    this.infoWindow.close()
    // kml削除
    if (this.mapLayers.length !== 0) {
      for (let i in this.soilScales) {
        this.mapLayers[i].setMap(null)
      }
    }
  }

  /* zoomによって土壌図の表示切替 */
  private changedZoom (zoom: any) {
    this.zoom = zoom
    if (this.selectedLayer === '1') {
      if (zoom <= 12 && this.soilScales !== this.soilScale20) {
        this.initMap('kml20')
      } else if (zoom > 12 && this.soilScales !== this.soilScale5) {
        this.initMap('kml5')
      }
    }
  }

  /* popアップを整形 */
  private showData (data: any) {
    /* popアップの情報取得 */
    let el: any = data.featureData.info_window_html
    if (this.soilScales === this.soilScale5) {
      /* 整形 */
      let a = el.replace('<table border="1">\n<tr><td>Code:</td><td>', ',')
      let b = a.replace('</tr>\n</table>\n', '')
      /* 配列に変換 */
      let array = b.split(',')
      /* 土の説明文取得 */
      let soilData = SoilClass.getSoilDetail(array[1])
      /* popアップの中身差し替え */
      return '<div style="max-width: 340px;"><p>' + '土壌分類名：' + '<span>' + soilData.name + '</span></br>土壌分類記号：' + soilData.code + '</p><p>' + soilData.detail + '</p></div>'
    } else {
      /* 整形 */
      let a = el.replace('<table border="1">\n<tr><td>Code:</td><td>', ',')
      let b = a.replace('</tr>\n<tr><td>Soil name:</td><td>', ',')
      let c = b.replace('</tr>\n', '')
      let d = c.replace('<tr><td>Content:</td><td>', ',')
      let e = d.replace('</tr>\n</table>\n', '')
      /* 配列に変換 */
      let array = e.split(',')
      /* popアップの中身差し替え */
      return '<div style="max-width: 340px;"><p>' + '土壌分類名：' + '<span>' + array[2] + '</span></br>土壌分類記号：' + array[1] + '</p><p>' + array[3] + '</p></div>'
    }
  }
}
